export default "__VITE_ASSET__DN8N1uym__"